(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aff-pilula"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-pilula')) {
    class AffPilula extends HTMLElement {
      connectedCallback() {
        const midia = this.parentElement;
        const botao = this.querySelector('.aff-pilula__botao');
        if ('IntersectionObserver' in window && midia) {
          this.io = new IntersectionObserver((es) => { this.classList.toggle('aff-pilula--on', es[0].intersectionRatio >= 0.35); }, { threshold: [0, 0.35, 0.6] });
          this.io.observe(midia);
        } else { this.classList.add('aff-pilula--on'); }
        botao && botao.addEventListener('click', () => {
          const aberto = this.classList.toggle('aff-pilula--aberto');
          botao.setAttribute('aria-expanded', String(aberto));
        });
      }
      disconnectedCallback() { this.io && this.io.disconnect(); }
    }
    customElements.define('aff-pilula', AffPilula);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aff-presente-topo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aff-presente')) {
    class AffPresente extends HTMLElement {
      connectedCallback() {
        // sai do bloco do menu e entra na área de ações do topo, antes da conta
        const acoes = this.closest('header-actions') ? null : document.querySelector('#header-component header-actions');
        if (acoes) { const conta = acoes.querySelector('.account-button'); conta ? acoes.insertBefore(this, conta) : acoes.prepend(this); return; }
        this.hidden = false;
        this.botao = this.querySelector('.aff-presente__botao'); this.painel = this.querySelector('.aff-presente__painel');
        if (!this.botao || !this.painel) return;
        this.botao.addEventListener('click', (e) => { e.stopPropagation(); this.alterna(); });
        this.fora = (e) => { if (!this.contains(e.target)) this.fecha(); };
        this.tecla = (e) => { if (e.key === 'Escape') this.fecha(); };
      }
      alterna() { this.painel.hidden ? this.abre() : this.fecha(); }
      abre() { this.painel.hidden = false; this.botao.setAttribute('aria-expanded', 'true'); document.addEventListener('click', this.fora); document.addEventListener('keydown', this.tecla); }
      fecha() { this.painel.hidden = true; this.botao.setAttribute('aria-expanded', 'false'); document.removeEventListener('click', this.fora); document.removeEventListener('keydown', this.tecla); }
      disconnectedCallback() { document.removeEventListener('click', this.fora); document.removeEventListener('keydown', this.tecla); }
    }
    customElements.define('aff-presente', AffPresente);
  }
  } catch(e) { console.error(e); }
})();

})();
